import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from "@angular/common";
import { BsRootModule } from 'ngx-bootstrap';
import { MaterialModule, MdNativeDateModule, DateAdapter, MD_DATE_FORMATS } from '@angular/material';
import { AppDateAdapter, APP_DATE_FORMATS } from '../../shared/AppDateAdapter';
//import { MaterialModule } from '../../shared/MaterialModule';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { LaddaModule } from 'angular2-ladda';
import { BusyModule } from 'angular2-busy';
import { CustomFormsModule } from 'ng2-validation';
import { ImageUploadModule } from "angular2-image-upload";
import { ToasterModule } from 'angular2-toaster';
import { APP_DIRECTIVES } from '../../common/directive/index';

import { APP_COMPONENTS } from '../index';
import { SHARED_COMPONENTS } from '../../shared/index';
import { APP_PROVIDERS } from '../../services/index';

import {StoreModule} from '@ngrx/store';
//import * as fromContacts from './store';
import { reducers } from '../../store/index';
import {EffectsModule} from '@ngrx/effects';
//import {ContactsEffects} from '../../store/effects/contacts-effects';
import {CommonEffects} from '../../store/effects/common.effects';
import { APP_PIPE } from "../../common/pipe";

@NgModule({
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule, CustomFormsModule,
        BsRootModule, MaterialModule, NgxDatatableModule, LaddaModule, BusyModule,
        ToasterModule,
        StoreModule.forFeature('appState', reducers),
        EffectsModule.forFeature([CommonEffects]),
        ImageUploadModule.forRoot()
    ],
    declarations: [APP_DIRECTIVES, APP_COMPONENTS, SHARED_COMPONENTS,APP_PIPE],
    entryComponents: [APP_COMPONENTS, SHARED_COMPONENTS],
    providers: [
        APP_PROVIDERS, DatePipe,
        {
            provide: DateAdapter, useClass: AppDateAdapter
        },
        {
            provide: MD_DATE_FORMATS, useValue: APP_DATE_FORMATS
        }
    ]
})

export class dynamicModule {

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/home/dynamic.module.ts